var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "color-container" }, [_c('div', { staticClass: "el-form-item__label color-label" }, [_vm._v(_vm._s(_vm.colorLabel))]), _vm._v(" "), _c('input-color', { attrs: { "value": _vm.colorValue[_vm.colorProp] }, on: { "change": _vm.handleChange } })], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };